import { render, staticRenderFns } from "./ServiceAlertSection.vue?vue&type=template&id=0cdee91d&"
import script from "./ServiceAlertSection.vue?vue&type=script&lang=js&"
export * from "./ServiceAlertSection.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports